import { GDFWmoCloudRecord } from '../../gdf/type';

export function mapTurbulenceSeverityToSeverityColor(cSeverity: number): number {
    let color: number;
    // smooth
    if (cSeverity == 0 || cSeverity == 4 || cSeverity == 8) {
        color = 0;
    }
    // light
    else if (cSeverity == 1 || cSeverity == 5 || cSeverity == 9) {
        color = 0;
    } else if (cSeverity >= 15 && cSeverity <= 17) {
        // light to moderate
        color = 0;
    } else if (cSeverity == 2 || cSeverity == 6 || cSeverity == 10) {
        // moderate values
        color = 1;
    }
    // moderate to severe values
    else if (cSeverity >= 18 && cSeverity <= 20) {
        color = 1;
    }
    // severe values
    else if (cSeverity == 3 || cSeverity == 7 || cSeverity == 11) {
        color = 2;
    } else if (cSeverity >= 21 && cSeverity <= 23) {
        // severe to extreme
        color = 2;
    } // default to extreme if we get through all these cases
    else {
        color = 3;
    }
    return color;
}

export function mapTurbulenceSeverityToPirepSymbol(cSeverity: number): number {
    let symbol: number;
    if (cSeverity == 0 || cSeverity == 4 || cSeverity == 8) {
        symbol = 1;
    }
    // light
    else if (cSeverity == 1 || cSeverity == 5 || cSeverity == 9) {
        symbol = 2;
    } else if (cSeverity >= 15 && cSeverity <= 17) {
        // light to moderate
        symbol = 4;
    } else if (cSeverity == 2 || cSeverity == 6 || cSeverity == 10) {
        // moderate values
        symbol = 4;
    }
    // moderate to severe values
    else if (cSeverity >= 18 && cSeverity <= 20) {
        symbol = 6;
    }
    // severe values
    else if (cSeverity == 3 || cSeverity == 7 || cSeverity == 11) {
        symbol = 6;
    } else if (cSeverity >= 21 && cSeverity <= 23) {
        // severe to extreme
        symbol = 7;
    } // default to extreme if we get through all these cases
    else {
        symbol = 7;
    }

    return symbol + 1;
}

export function buildCloudLabel(record: GDFWmoCloudRecord): string {
    let dist = '';
    if (record.dist > 0 && record.cloudType > 0 && record.iceLevel == 0 && record.turbLevel == 0) {
        // find the cloud distribution
        switch (record.dist) {
            case 1: // skyclear
                dist = 'SKC';
                break;
            case 2: // few
                dist = 'FEW';
                break;
            case 3: // scattered
                dist = 'SCT';
                break;
            case 4: // broken
                dist = 'BKN';
                break;
            case 5: // overcast
                dist = 'OVC';
                break;
            case 6: // scattered/broken
                dist = 'SCTBKN';
                break;
            case 7: // broken/overcast
                dist = 'BKNOVC';
                break;
            case 8: // Isolated
                dist = 'ISOL';
                break;
            case 9: //Isolated/embedded
                dist = 'ISOLEMBED';
                break;
            case 10: // occasional
                dist = 'OCNL';
                break;
            case 11: // occasional/embedded
                dist = 'OCNLEMBED';
                break;
            case 12: // frequent
                dist = 'FRQ';
                break;
            case 13: // dense
                dist = 'DNS';
                break;
            case 14: // layers
                dist = 'LYR';
                break;
        }

        let type = '';
        // find the cloud type
        switch (record.cloudType) {
            case 1: // Ci  cirrus
                type = 'Ci';
                break;
            case 2:
                type = 'Cc';
                break;
            case 3:
                type = 'Cs';
                break;
            case 4:
                type = 'Ac';
                break;
            case 5:
                type = 'As';
                break;
            case 6:
                type = 'Ns';
                break;
            case 7:
                type = 'Sc';
                break;
            case 8:
                type = 'St';
                break;
            case 9:
                type = 'Cu';
                break;
            case 10:
                type = 'Cb';
                break;
            case 11:
                type = 'Ch';
                break;
        }

        const tops = record.cloudTops?.toString() ?? '---';
        const base = record.cloudBase?.toString() ?? '---';

        return [dist, type, tops, base].filter(Boolean).join('\n');
    }
    return '';
}
